/** The card chrome the Pay rates states share: the box and its heading. */
import { DollarSign } from 'lucide-react';
import type { ReactNode } from 'react';

export default function PayRatesCardFrame({ children }: { children: ReactNode }) {
  return (
    <section className="bg-white dark:bg-[#1e2521] rounded-2xl border border-stone-200 dark:border-stone-700 p-5">
      <h2 className="flex items-center gap-2 text-sm font-semibold text-bark-900 dark:text-stone-100 mb-4">
        <DollarSign size={14} className="text-moss-600 dark:text-moss-400" />
        Pay rates
      </h2>
      {children}
    </section>
  );
}
